export const groupSearchScopes = Object.freeze({
  INSTITUTIONAL: 'institutional',
  MUNICIPAL: 'municipal',
  ADMINISTRATIVE_AUTHORITY: 'administrative_authority',
  CROSS_INSTITUTIONAL: 'cross_institutional',
});
